import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'unit-info',
	templateUrl: './unit-info.component.html',
	styleUrl: './unit-info.component.scss'
})

export class UnitInfoComponent implements OnInit, OnChanges, OnDestroy {

	@Input() id = 0
	@Input() course = 0
	@Input() multitransl = false
	@Input() transl = 'es'

	name = ''
	lessonsNum = 0
	summary = false
	glossary = false
	glossaryWordsNum = 0

	getUnitInfoSub = new Subscription

	constructor(private dataService: ApiService) {}

	ngOnInit() {}

	ngOnChanges() {
		this.getUnitInfoSub = this.dataService.getUnitInfo(this.id)
		.subscribe({
			next: (unit) => {
				console.log(unit)
				this.name = unit.name
				this.lessonsNum = unit.lessons
			},
			error: (e) => {
				console.log(e)
			},
		})
	}

	ngOnDestroy() {
		this.getUnitInfoSub?.unsubscribe()
	}

}
